import { render, staticRenderFns } from "./Fundementals.vue?vue&type=template&id=72f97fe7&scoped=true"
import script from "./Fundementals.vue?vue&type=script&lang=js"
export * from "./Fundementals.vue?vue&type=script&lang=js"
import style0 from "./Fundementals.vue?vue&type=style&index=0&id=72f97fe7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f97fe7",
  null
  
)

export default component.exports